









































































































































































































































































































































































import Vue from "vue";
import store from "./store/index";
import { mapGetters } from "vuex";
import MainView from "./views/main/MainView.vue";
import ResponseError from "@/components/shared/ReponseError.vue";
import AutoLogout from "@/components/shared/AutoLogout.vue";
import Snackbar from "@/components/shared/Snackbar.vue";
import Unauthorized from "@/components/shared/Unauthorized.vue";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const { useState } = createNamespacedHelpers("ui");

export default Vue.extend({
  name: "App",
  components: {
    MainView,
    ResponseError,
    Snackbar,
    AutoLogout,
    Unauthorized,
  },

  data() {
    return {
      selectIsOpen: false,
      ordersIsOpen: false,
      infoIsOpen: false,
      monitorIsOpen: false,
    };
  },

  created() {
    this.$log.debug("App.vue has been created...");
  },

  setup() {
    const { window } = useState(["window"]);
    return {
      window,
    };
  },

  computed: {
    ...mapGetters(["user_details", "account_details", "monitorsEnabled"]),

    is_logged_in() {
      return store.state.logged_in;
    },

    is_route_with_map() {
      const { fullPath, path, query, name } = this.$route;
      return (
        fullPath === "/select" ||
        fullPath === "/explore" ||
        fullPath === "/orders-place" ||
        (path === "/select" && query && query.view) ||
        name === "monitor-details" ||
        name === "create-monitor"
      );
    },

    get_docs_for_route() {
      const { fullPath } = this.$route;
      const base_url = process.env.VUE_APP_DOCS_URL;
      if (fullPath === "/select") {
        return `${base_url}/select/select_imagery/`;
      }
      if (fullPath.startsWith("/selects")) {
        return `${base_url}/select/view_selections/`;
      }
      if (fullPath === "/orders-place") {
        return `${base_url}/order/place_order/`;
      }
      if (fullPath.startsWith("/orders")) {
        return `${base_url}/order/view_orders/`;
      }
      if (fullPath === "/explore") {
        return `${base_url}/explore/explore/`;
      }
      if (fullPath.startsWith("/accounts")) {
        return `${base_url}/manage/account/`;
      }
      if (fullPath.startsWith("/users/account")) {
        return `${base_url}/manage/manage_users/manage_users/`;
      }
      if (fullPath === "/create_user") {
        return `${base_url}/manage/manage_users/add_user/`;
      }
      if (fullPath.startsWith("/admin/account")) {
        return `${base_url}/manage/manage_users/view_edit_user/`;
      }
      if (fullPath.startsWith("/usage/account")) {
        return `${base_url}/manage/usage/`;
      }
      if (fullPath.startsWith("/credentials")) {
        return `${base_url}/manage/manage_credentials/credentials_overview/`;
      }
      if (fullPath === "/create_credentials") {
        return `${base_url}/manage/manage_credentials/add_credentials/`;
      }

      return `${base_url}`;
    },
  },
});
